import Vue from "vue";
import App from "./App.vue";

import "./assets/common.less";
import dataV from "@jiaminghi/data-view";
import store from "./store";
import moment from 'moment';
import 'moment/locale/zh-cn';
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Swiper2, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import echarts from "echarts"
Vue.prototype.$echarts = echarts
Swiper2.use([Navigation, Pagination, EffectFade, Autoplay])

Vue.use(vueSwiper)

moment.locale('zh-cn')

Vue.config.productionTip = false;

Vue.use(dataV);

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
